export default __webpack_public_path__ + "static/media/physical-prototypes.c150f325.svg";